<template>
  <div class="author">
    <Info
      v-if="author"
      :author="author"
    />
    <Skeleton
      v-else
      :loading="loading"
    />
  </div>
</template>

<script lang="ts" setup>
  import { onBeforeMount } from 'vue';
  import { useRoute } from 'vue-router';

  import { useAuthorEntity } from '@/pages/author/entities/author';

  import Info from './Info.vue';
  import Skeleton from './Skeleton.vue';

  const route = useRoute();

  const { loading, author, getAuthor } = useAuthorEntity();

  onBeforeMount(() => getAuthor(Number(route.params.id)));
</script>
